export function isSupportedBrowser(browserSupport) {
  return new RegExp(browserSupport.regex).test(window.navigator.userAgent);
}
export function isFirefox() {
  return /firefox/i.test(window.navigator.userAgent);
}
export const isTouchSupported = () => typeof window !== "undefined" && !!("ontouchstart" in window || navigator.maxTouchPoints > 0);
export const getCrossorigin = (crossorigin, defaultCrossOrigin) => {
  if (crossorigin === true) {
    return "anonymous";
  }
  return crossorigin === void 0 ? defaultCrossOrigin || "anonymous" : crossorigin;
};
